import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/styles';
import DialogContentText from '@material-ui/core/DialogContentText';
import Fade from '@material-ui/core/Fade';
import QrReader from "react-qr-reader";
import Auth from "../../../../utils/Auth";
import clsx from 'clsx';
import { FormControlLabel, FormLabel, RadioGroup, FormHelperText, FormControl, Radio, Button, Tooltip } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import InfoIcon from '@material-ui/icons/Info';
import Utils from "../../../../utils/Utils";
import { deleteUserPaymentInstrument } from './../../../../payments/epay/epay.actions';
import applePayIcon from './../../../../icons/apple-pay.png';
import googlePayIcon from './../../../../icons/google-pay.png';
import mastercardIcon from './../../../../icons/mastercard.png';
import visaIcon from './../../../../icons/visa.png';
import bizumIcon from './../../../../icons/bizum_payment_logo.png';

class PaymentMethods extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount() {
        this.setState({ errors: '' });
    }

    handleDeleteUserPaymentInstrument(instrumentId) {
        this.props.onChange({ target: { name: "payment_instrument", value: null } })
        this.props.deleteUserPaymentInstrument(instrumentId);
    }

    render() {
        const orderTypeUsedForPaymentMethodLabel = this.props.currentOrderType == 2 ? '_delivery' : ''


        return (
            <React.Fragment>
                {this.props.paymentMethods && Object.values(this.props.paymentMethods).length > 0 ?
                    <span className={clsx(this.props.classes.textFieldContainer, this.props.classes.paymentMethodContainer)}>
                        <FormControl component="fieldset" error={this.props.omdata.customErrors && this.props.omdata.customErrors.payment_method} >
                            <FormLabel component="legend" className={this.props.classes.orderLabel}>{this.props.translations.payments.choose_payment_method}:</FormLabel>
                            <RadioGroup row aria-label="position" name="payment_method" value={this.props.omdata.payment_method}> {/* defaultValue="cash" */}
                                {this.props.paymentMethods.map(p =>
                                    p !== 'epay' || Utils.hasFunctionalityModule('payments') ?   // show epay only if payments are allowed
                                        <FormControlLabel
                                            value={p}
                                            control={<Radio className={this.props.classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                            label={this.props.translations.pages.cart_delivery && this.props.translations.pages.cart_delivery['payment_' + p + orderTypeUsedForPaymentMethodLabel] ? this.props.translations.pages.cart_delivery['payment_' + p + orderTypeUsedForPaymentMethodLabel] : ''}
                                            labelPlacement={p}
                                        />
                                        :
                                        null
                                )}
                            </RadioGroup>
                            {Utils.hasFunctionalityModule('payments') && this.props.omdata.payment_method === 'epay' ?
                                <React.Fragment>
                                    <RadioGroup row aria-label="position" name="payment_instrument" value={this.props.omdata.payment_instrument}> {/* defaultValue="cash" */}
                                        {Auth.getDecodedUser() && this.props.userPaymentInstruments && this.props.userPaymentInstruments.map(pi => (
                                            <>
                                                <FormControlLabel
                                                    value={pi.id}
                                                    control={<Radio className={this.props.classes.orderRadio} onClick={(e) => this.props.onChange(e)} />}
                                                    label={pi.name}
                                                    labelPlacement={pi.name}
                                                />
                                                <Tooltip title="TabL не пази данните на Вашата кредитна карта. Всички картови транзакции се обработват от институция за сигурни плащания, сертифицирана от БНБ.">
                                                    <InfoIcon style={{ paddingTop: 5, paddingRight: 7, cursor: "pointer" }} />
                                                </Tooltip>

                                                <Tooltip title="Изтрий">
                                                    <DeleteIcon onClick={() => this.handleDeleteUserPaymentInstrument(pi.id)} style={{ paddingTop: 5, cursor: "pointer" }} />
                                                </Tooltip>
                                            </>
                                        ))}
                                    </RadioGroup>

                                </React.Fragment>
                                :
                                null
                            }

                            
                            <FormHelperText>{this.props.omdata.customErrors && this.props.omdata.customErrors.payment_method ? this.props.omdata.customErrors.payment_method : ''}</FormHelperText>
                        </FormControl>
                        {Utils.hasFunctionalityModule('payments') && this.props.paymentMethods.find(p => p == 'online') ?
                            <React.Fragment>
                                <ul class="pay-online" style={{display: "flex", justifyContent: "space-between", paddingLeft: 0, marginBottom: 0, listStyle: 'none'}}>
                                    
                                    <li><img width="52px" src={mastercardIcon} alt="mastercard pay icon"/></li>
                                    <li><img width="52px" src={visaIcon} alt="visa pay icon"/></li>

                                    {this.props.paymentMethods.find(p => p == 'online.bizum') ? 
                                        <React.Fragment>
                                            <li><img width="52px" src={bizumIcon} alt="google pay icon"/></li> 
                                        </React.Fragment>
                                    :
                                        <React.Fragment>
                                            <li><img width="52px" src={googlePayIcon} alt="google pay icon"/></li> 
                                            <li><img width="52px" src={applePayIcon} alt="apple pay icon"/></li>
                                        </React.Fragment>
                                    }
                                </ul>
                            </React.Fragment>
                        :
                            null
                        }
                        {Utils.hasFunctionalityModule('payments') && this.props.omdata.payment_method === 'epay' && Auth.getDecodedUser() && this.props.userPaymentInstruments.length > 0 ?
                            <Button onClick={() => {
                                // this.props.onChange({ target: { name: "payment_instrument", value: null } })
                                this.props.submitOrder(this.props.currentOrderType, true)
                            }}
                                className={this.props.classes.changePaymentInstrumentButton}>Смени карта и Плати</Button>
                            :
                            null
                        }

                    </span>
                    :
                    null
                }
            </React.Fragment>
        )
    }

}



const mapStateToProps = (state, ownProps) => {

    return {
        translations: state.lang.translations,
        userPaymentInstruments: state.users.payment_instruments
    }
};

export default (connect(mapStateToProps, { deleteUserPaymentInstrument })(PaymentMethods));
